import { render, staticRenderFns } from "./pcrole.vue?vue&type=template&id=4c5e4449&"
import script from "./pcrole.vue?vue&type=script&lang=js&"
export * from "./pcrole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports